module.exports = __webpack_public_path__ + "static/media/danna1.3f7b46f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/danna1.png
// module id = 952
// module chunks = 0